import { SITE } from 'src/app/shared/constants/configObjectProperties';
import { IntercomConfiguration } from 'src/app/shared/intercom';
import { getConfig } from 'src/app/utils/config';
import { PageViewTracker } from 'src/app/v1/dataAnalytics/PageViewTracker';
import { useAdvertiserId } from 'src/app/v1/views/hooks/useAdvertiserId';
import { useCurrentUser } from 'src/app/v1/views/hooks/useCurrentUser';
import { useDataCleanup } from 'src/app/v1/views/hooks/useDataCleanup';
import { useFlowType } from 'src/app/v1/views/hooks/useFlowType';
import { useHirerAccountAndContractBalance } from 'src/app/v1/views/hooks/useHirerAccountAndContractBalance';
import { useIdentity } from 'src/app/v1/views/hooks/useIdentity';
import { useJobData } from 'src/app/v1/views/hooks/useJobData';
import { useJobId } from 'src/app/v1/views/hooks/useJobId';
import { usePageId } from 'src/app/v1/views/hooks/usePageId';
import { useTealiumFlowType } from 'src/app/v1/views/hooks/useTealiumFlowType';
import type { ContainerProps } from 'src/types/app';

const MultiLocationContainer = ({ children }: ContainerProps) => {
  const { isLoading } = useDataCleanup();
  usePageId(isLoading);
  useFlowType('multilocation');
  useTealiumFlowType('multilocation');
  useAdvertiserId();
  useJobId();
  useHirerAccountAndContractBalance();
  useCurrentUser();
  useIdentity();
  useJobData();

  return (
    <>
      <PageViewTracker />
      <IntercomConfiguration site={getConfig(SITE)} />
      {children}
    </>
  );
};

export default MultiLocationContainer;
